import * as React from 'react'

import ProductList from 'src/components/ProductList'
import { IProductList } from 'src/models/product'
import { observer } from 'mobx-react'
import FilterSort from './FilterSort'
import Pagination from './Pagination'
import ProductFilters from './ProductFilters'
import trans from '../utils/translations'

class FilterHolder extends React.Component<{ productList: IProductList }, {}> {
    public render() {
        const { productList } = this.props
        return (
            <div className="product-holder">
                <div className="row">
                    <div className="small-12 large-9 columns right">
                        <div className="row">
                            <div className="small-12 columns">
                                <div className="top-filter-holder" id="top-filter-holder">
                                    <div className="amount-holder">
                                        <span>
                                            <span className="amount">{productList.entries}</span>{' '}
                                            {trans.t('resultaten')}
                                        </span>
                                    </div>
                                    <FilterSort productList={productList} />
                                </div>
                            </div>

                            <ProductList productList={productList} />

                            <div className="small-12 columns">
                                <Pagination
                                    currentPage={productList.page}
                                    numberOfPages={productList.pages}
                                    onClick={(p: number) => {
                                        productList.goToPage(p)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="small-12 large-3 columns left" id="filter-holder">
                        <div className="filter-holder">
                            <ProductFilters productList={productList} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default observer(FilterHolder)



// WEBPACK FOOTER //
// ./react/src/components/FilterHolder.tsx